import React, { useContext } from "react";
import AppContext from "../contexts/AppContext";
import BannerArea1 from "./BannerArea1";
import WithLoader from "./WithLoader";

function MainBannerModuleArea1({ children, setLoading }) {
  const { context, setContext } = useContext(AppContext);

  let menuList =
    context?.pageConfig?.subcomponents[0]?.subcomponents[0]?.subcomponents[0];

  return (
    <div className="lg:px-8 px-4 pb-8 pt-4 lg:pt-8 w-rb overflow-auto">
      <BannerArea1 {...menuList} setLoading={setLoading} />

      <div className="grid h-full pt-4">{children}</div>
    </div>
  );
}

export default WithLoader(MainBannerModuleArea1);
